module.exports = __webpack_public_path__ + "static/126195b4-2fa0-4b95-b5cf-ad9bf10193f0-c355e3afcbb8af73a1fcf52f113e42b4.ttf";